module.exports = __webpack_public_path__ + "img/BI.4609f1b6.png";